import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../services/guard/auth.service';
import { LocalService } from '../../services/storage/local.service';
import { CardModule } from 'primeng/card';
import { Message } from 'primeng/message';
import { MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-authentication',
  standalone: true,
  imports: [ButtonModule, CardModule, Message],
  templateUrl: './authentication.component.html',
  styleUrl: './authentication.component.scss',
  providers: [MessageService],
})
export class AuthenticationComponent implements OnInit {
  @Input() loggedIn;
  error;
  env;
  constructor(
    private readonly authService: AuthService,
    private readonly localService: LocalService,
    private readonly messageService: MessageService,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.env = environment.environment;
    this.route.queryParams.subscribe((params) => {
      if(params['error'] !== undefined) {
        this.error = 
          {
            severity: 'error',
            text: "Un problème est survenu. Veuillez essayer de vous reconnecter. Si le problème persiste, contactez l'administrateur de votre boutique pour obtenir de l'aide.",
          };
      }
    });
  }

  login(role): void {
    this.localService.setItem('userType', role);
    this.authService.login(role);
  }
}
